module.exports = "<nv-react-component component=\"PracticeScenarios\" dispatch-store-updates=\"false\"></nv-react-component>";